import React from "react";
import { Modal, Space, Button, Typography, Tag } from "antd";
import { COLORS } from "../types/types";
import StripeWrapper from '../page/client/StripeWrapper';
import PaymentFormExport from '../page/client/PaymentFormExportCredits';

const { Text } = Typography;

interface ProfessionExportModalProps {
  visible: boolean;
  profession: any | null;
  amount: number;
  showPayment: boolean;
  userId: number | null;
  onCancel: () => void;
  onShowPayment: () => void;
  onSuccess: () => void;
  onExport: (profession: any) => void; // ← NOUVELLE PROP
}

const ProfessionExportModal: React.FC<ProfessionExportModalProps> = ({
  visible,
  profession,
  amount,
  showPayment,
  userId,
  onCancel,
  onShowPayment,
  onSuccess,
  onExport, // ← DÉSTRUCTURER
}) => {
  if (!profession) return null;

  // ✅ Gestionnaire de succès du paiement
  const handlePaymentSuccess = () => {
    // 1. Lancer l'export
    onExport(profession);
    // 2. Fermer la modale
    onSuccess();
  };

  return (
    <Modal
      title="Paiement sécurisé - Export par profession"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={500}
      destroyOnClose
    >
      {!showPayment ? (
        <div style={{ padding: "24px 0", textAlign: "center" }}>
          <div style={{ marginBottom: 24 }}>
            <Text strong style={{ fontSize: 18 }}>{profession.name}</Text>
            <div style={{ marginTop: 8 }}>
              <Tag color={profession.isFree ? "green" : "orange"} style={{ fontSize: 14, padding: "4px 12px" }}>
                {profession.isFree ? "Gratuit" : "Payant"}
              </Tag>
            </div>
          </div>
          
          <div style={{ padding: 24, backgroundColor: COLORS.light, borderRadius: 8, marginBottom: 16 }}>
            <Text type="secondary">Montant à payer</Text>
            <div style={{ fontSize: 48, fontWeight: "bold", color: COLORS.secondary }}>
              {amount.toFixed(2)} €
            </div>
          </div>
          
          <Space>
            <Button onClick={onCancel}>Annuler</Button>
            <Button
              type="primary"
              onClick={onShowPayment}
              style={{ backgroundColor: COLORS.primary, borderColor: COLORS.primary }}
            >
              Payer {amount.toFixed(2)} €
            </Button>
          </Space>
        </div>
      ) : (
        <StripeWrapper>
          <PaymentFormExport
            amount={amount}
            userId={userId || 0}
            professionName={profession.name}
            fileName={`annuaire_${profession.name}_${new Date().toISOString().slice(0, 10)}.xlsx`}
            onSuccess={handlePaymentSuccess}
            onCancel={onCancel}
          />
        </StripeWrapper>
      )}
    </Modal>
  );
};

export default ProfessionExportModal;